import "./Signup.scss";
import {
  Button,
  Col,
  Flex,
  Form,
  Grid,
  Input,
  Layout,
  Radio,
  Row,
  notification,
} from "antd";
import React, { useState } from "react";
import Logo from "../../components/Logo/Logo";
import { AuthMessages, ILoginViewProps, TokenType } from "../..";
import {
  NotificationPlacement,
  IconType,
} from "antd/es/notification/interface";
import { useNavigate } from "react-router-dom";
import store from "../../../controllers/store";
import {
  clear,
  signup,
} from "../../../controllers/store/actions/signup/signup-actions";
import { useSelector } from "react-redux";
import MaskedInput from "antd-mask-input";
import Footer from "../../components/Footer/Footer";
import PublicMenu from "../../components/Menu/PublicMenu";
const { useBreakpoint } = Grid;
const dispatch = store.dispatch;

const SignUp: React.FC = (props: ILoginViewProps) => {
  const screens = useBreakpoint();

  const [form] = Form.useForm();
  const signupData = useSelector((state: any) => state.signup);
  const [loading, setLoading] = useState<boolean>(false);
  const [notify, setNotification] = useState(false);
  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const openNotification = (placement: NotificationPlacement) => {
    api.info({
      key: "2",
      type: TokenType.success as IconType,
      message: AuthMessages.Title,
      description: AuthMessages.AccountCreated,
      placement,
    });
  };

  const options = [
    { label: "Consumidor de conocimiento", value: "KnowledgeConsumer" },
    { label: "Proveedor de conocimiento", value: "KnowledgeProvider" },
  ];

  const openNotificationError = (placement: NotificationPlacement) => {
    api.error({
      key: "1",
      type: TokenType.error as IconType,
      message: AuthMessages.Title,
      description: AuthMessages.AccountCreatedError,
      placement,
    });
  };

  return (
    <>
      {contextHolder}
      <Layout style={{ height: "100vh", background: "none" }}>
        {signupData.error?.data && openNotificationError("top")}
        {signupData.data?.id && (window.location.href = "/login")}
        <Row
          className={screens.xs ? "movil-view" : "signup-view"}
          justify={"center"}
          align={"middle"}
        >
          <div className="menu-movil">
            <PublicMenu />
          </div>
          <Col xs={24} lg={10}>
            <Col
              offset={0}
              xs={24}
              className={screens.xs ? "text-centered" : ""}
            >
              <Logo size={"100%"} />
            </Col>
            <Col offset={0} xs={24}>
              <h2 className={screens.xs ? "text-centered mb-0" : ""}>
                Crear cuenta
              </h2>
            </Col>
            <Form
              form={form}
              onFinish={async (values: any) => {
                setLoading(true);
                form.validateFields().then(async (values: any) => {
                  console.log("values", values);
                  try {
                    await dispatch(signup(values));
                    setIsModalRegisterOpen(false);
                    setLoading(false);
                    dispatch(clear());
                  } catch (error) {
                    setLoading(false);
                  }
                });
              }}
              layout="vertical"
              name="Registrarse"
            >
              <Row gutter={16}>
                <Col xs={24} lg={12}>
                  <Form.Item
                    style={{ width: "100%" }}
                    label="Nombres"
                    name="first_name"
                    rules={[{ type: "string", required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item
                    style={{ width: "100%" }}
                    label="Apellidos"
                    name="last_name"
                    rules={[{ type: "string", required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ type: "email", required: true }]}
                    style={{ width: "100%" }}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Confirmar Email"
                    name="confirmEmail"
                    rules={[
                      { required: true },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("email") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject("Los emails no coinciden");
                        },
                      }),
                    ]}
                    style={{ width: "100%" }}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                label="Télefono"
                name="phone"
                rules={[{ type: "string", required: true }]}
              >
                <MaskedInput mask={"+57(000)000-0000"} />
              </Form.Item>
              <Form.Item
                name="role"
                label="Registrarme como:"
                rules={[{ type: "string", required: true }]}
              >
                <br />
                <Flex vertical gap="middle">
                  <Radio.Group
                    onChange={(e) =>
                      form.setFieldsValue({ role: e.target.value })
                    }
                    size="small"
                    options={options}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Flex>
              </Form.Item>
              <Form.Item wrapperCol={{ span: 24 }}>
                <Button
                  loading={loading}
                  type="primary"
                  size={"large"}
                  block
                  htmlType="submit"
                >
                  Crear cuenta
                </Button>
              </Form.Item>
            </Form>
            <p className="flex-centered">
              Ya tengo una cuenta
              <a
                href="#/"
                onClick={($event) => {
                  $event.preventDefault();
                  navigate("/login");
                }}
                style={{ marginLeft: 10, color: "#f37221", fontWeight: 500 }}
              >
                Entrar
              </a>
            </p>
            <a
              href="#/"
              className="flex-centered"
              style={{ marginLeft: 10, color: "#f37221", fontWeight: 500 }}
            >
              Privacidad de datos
            </a>
          </Col>
          <Col className="image hidde-mobile" xs={24} lg={14}></Col>
          {screens.xs ? <Footer /> : null}
        </Row>
      </Layout>
    </>
  );
};

export default SignUp;
